import { useEffect, useState } from 'react'
import { Box, Container, Typography } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import Card from '../../components/Card'
import Layout from '../../components/Layout'
import { useLocation, useNavigate } from 'react-router-dom'
import Utils from '../../../utils'
import { useGetBusinessAccounts, useGetPaymentMethods, usePayQuote } from '../../container/hooks/usePayment'
import LocalStorage from '../../../defined/localStorage'
import Button from '../../common/Button'
import OrderPlacedModal from '../../components/OrderPlacedModal'
import { translate } from '../../../helper'
import { useSelector } from 'react-redux'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import PageBox from './components'
import { ENV } from '../../../Env'
import CustomSpinner from '../../../common/CustomSpinner';
import PaymentDescription from './PaymentDescription'

const brand = JSON.parse(LocalStorage.getItem('branding'))
const getCurrencySymbol = (currency = 'USD', locale = 'en-US') => (0).toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
}).replace(/\d/g, '').trim()

const endpoint = ENV.EXCHANGE_RATE_API;

function PaymentMethod() {
    const whiteLabel = useSelector((state) => state.User?.branding)
    const [loading, setLoading] = useState(true)
    const paymentConfig = useSelector((state) => state.User?.order_config)
    const [cards, setCards] = useState([])
    const [businessCards, setBusinessCards] = useState([])
    const [selectedCard, setSelectedCard] = useState({})
    const [isOrderPlaced, setIsOrderPlaced] = useState(false)
    const [orderResponse, setOrderResponse] = useState('')
    const [rsponse, setResponse] = useState('')
    const [payments, setPayments] = useState([])
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const { payQuote, isPayingQuotation } = usePayQuote(
        onSuccessPayment,
        onErrorPayment
    )

    async function onSuccessPayment(data) {
        setSuccessData({ ...successData, status: data?.status })
        setIsOrderPlaced(true)
        setOrderResponse('success')
    }

    async function onErrorPayment(data) {
        setIsOrderPlaced(true)
        setOrderResponse('error')
        if (data?.data?.quote?.[0]) {
            setResponse(data?.data?.quote?.[0] || '')
        }
    }

    const navigate = useNavigate()
    const location = useLocation()

    let quote = {}
    if (location?.state?.paymentFlow) {
        if (location?.state) {
            LocalStorage.setItem('quote_data', JSON.stringify(location?.state))
        }
        quote = JSON.parse(LocalStorage.getItem('quote_data') || '{}') || location?.state || {}
    } else {
        LocalStorage.removeItem('quote_data')
        quote = location?.state || {}
    }
    const [successData, setSuccessData] = useState({
        po: quote?.order?.id,
        order: quote?.order?.name,
        dealer: quote?.vendor?.business_name,
        amount: quote?.total_amount,
    })

    const { getPymentData } = useGetPaymentMethods(getPaymentMethodData)

    const { getBusinessAccounts } = useGetBusinessAccounts(getBusinessPaymentMethodData)

    function getPaymentMethodData(data) {
        let def = data?.filter(e => e?.is_default)[0] || selectedCard
        setSelectedCard(def)
        setCards([...(data?.map(e => e?.is_default ? { ...e, selected: true } : e) || [])])
    }

    function getBusinessPaymentMethodData(data) {
        let def = data?.filter(e => e?.default)[0] || selectedCard
        setSelectedCard(def)
        setBusinessCards([...(data.map(e => e?.default ? { ...e, selected: true } : e) || [])])
    }

    const handlePay = () => {
        const id = selectedCard?.type === 'card' ? selectedCard?.djstripe_id : selectedCard?.id
        setSuccessData({
            po: quote?.order?.id,
            order: quote?.order?.name,
            dealer: quote?.vendor?.business_name,
            amount: quote?.total_amount,
        })
        const payload =
            selectedCard?.type === 'card'
                ? {
                    quote: quote?.id,
                    payment_method: id,
                    parts: quote?.parts,
                    type: selectedCard?.type
                }
                : {
                    quote_id: quote?.id,
                    payment_method_id: id,
                    parts: quote?.parts,
                }
        payQuote(payload)
        LocalStorage.removeItem('quote_data')
    }

    const handleSelectcard = (type, id) => {

        if (type === 'business_card') {
            let selected = businessCards.filter(e => e?.id === id)[0]
            setSelectedCard(selected)
            setBusinessCards([...businessCards.map(e => e?.id === id ? { ...e, selected: true } : {
                ...e,
                selected: false
            })])
            if (!quote?.id) {
                navigate(`/customer/edit-business-card/${selected.id}`)
            }
        } else {
            setBusinessCards([...businessCards.map(e => ({ ...e, selected: false }))])
        }
        if (type === 'card') {
            let selected = cards.filter(e => e?.djstripe_id === id)[0]
            setSelectedCard(selected)
            setCards([...cards.map(e => e?.djstripe_id === id ? { ...e, selected: true } : { ...e, selected: false })])
            if (!quote?.id) {
                navigate(`/customer/edit-card/${selected.djstripe_id}`)
            }
        } else {
            setCards([...cards.map(e => ({ ...e, selected: false }))])
        }
    }

    useEffect(() => {
        (async () => {
            const shouldFetchPaymentMethods = !quote?.id || !!quote?.isStripeAccountConnected
            if (shouldFetchPaymentMethods) await getPymentData()
            await getBusinessAccounts()
            await fetchRates()
        })()
    }, [])

    async function fetchRates(base = 'USD') {
        const res = await fetch(`${endpoint}/${base}`)
        const rates = await res.json()
        setPayments(rates?.rates || {})
        setLoading(false)
    }

    const blueDescription = cards.length > 0
        ? "Selecting the Blue Card will charge the credit card you have on file to complete the order transaction."
        : "Add a credit card to complete order transactions using Credit Card Payment."

    const blackDescription = businessCards.length > 0
        ? "Selecting the Black Card will bill your dealership credit line (House Account) associated with your business or personal account at this dealership. Please ensure the information you enter matches your business or personal profile on file so the Parts Department can accurately charge your account."
        : "Add your dealership House Account to bill orders through the Parts Department."

    return (
        <Layout showNavigation showCentreProfile withoutname showNotification>
            <PageBox>
                <div style={{ backgroundColor: '#fff', height: 'unset' }} className="title">
                    {translate('paymentMethod')}
                </div>
                <div
                    className="payment-method"
                    style={{
                        width: '100%',
                        height: quote?.id && selectedCard && Object.keys(selectedCard).length > 0 ? '80%' : '90%',
                        display: 'flex',
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        flexDirection: 'column',
                        position: 'relative',
                        overflowY: 'auto'
                    }}
                >

                    <Container>
                        {
                            loading ?

                                <CustomSpinner fullPage top={0} />
                                :
                                <>
                                    {cards.length > 0 && <PaymentDescription
                                        title="Blue Card – Credit Card Payment"
                                        description={blueDescription}
                                        marginBottom={0}
                                    />}
                                    {
                                        cards.map((cardData, i) => (
                                            <Card
                                                key={cardData.id}
                                                cardData={cardData}
                                                className="card-data"
                                                type="card"
                                                selected={selectedCard?.djstripe_id === cardData?.djstripe_id}
                                                selectCard={handleSelectcard}
                                            />
                                        ))
                                    }
                                    {businessCards.length > 0 && <PaymentDescription
                                        title="Black Card – Dealership Credit Line / House Account"
                                        description={blackDescription}
                                        marginTop={2}
                                        marginBottom={0}
                                    />}
                                    {
                                        businessCards?.map((cardData, i) => (
                                            <Card
                                                key={cardData.id}
                                                cardData={cardData}
                                                className="card-data"
                                                selected={selectedCard?.id === cardData?.id}
                                                type="business_card"
                                                selectCard={handleSelectcard}
                                            />
                                        ))
                                    }
                                    {
                                        !(cards.length > 0 || businessCards?.length > 0)
                                            ? <>
                                                <PaymentDescription
                                                    title="Blue Card – Credit Card Payment"
                                                    description={blueDescription}
                                                    marginBottom={0}
                                                />
                                                <Card
                                                    className="add-card"
                                                    mode="add"
                                                    navigate={() => navigate(Utils.EndPoint.userMobileEndpoints.addNewCard, { state: { ...location?.state } })}
                                                />
                                                <PaymentDescription
                                                    title="Black Card – Dealership Credit Line / House Account"
                                                    description={blackDescription}
                                                    marginBottom={0}
                                                    marginTop={2}
                                                />
                                                <Card
                                                    className="add-business-card"
                                                    type="business-card"
                                                    mode="add"
                                                    navigate={() => navigate(Utils.EndPoint.userMobileEndpoints.addNewBusinessCard, { state: { ...location?.state } })}
                                                />
                                            </>
                                            :
                                            <Box
                                                id="basic-button"
                                                onClick={handleClick}
                                                sx={{
                                                    position: 'fixed',
                                                    bottom: '150px',
                                                    right: '16px',
                                                    width: 56,
                                                    height: 56,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#fff',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
                                                    zIndex: 1000,
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <AddCircleIcon
                                                    sx={{
                                                        fontSize: 32,
                                                        color: brand?.mobile_button_color || '#F8B218'
                                                    }}
                                                />
                                            </Box>
                                    }
                                </>
                        }
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            transformOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            PaperProps={{
                                sx: {
                                    width: 260,
                                    maxWidth: '90vw'
                                }
                            }}
                        >
                            <MenuItem
                                sx={{
                                    whiteSpace: 'normal',
                                    lineHeight: 1.4,
                                    py: 1.5
                                }}
                                onClick={() => navigate(Utils.EndPoint.userMobileEndpoints.addNewCard, { state: { ...location?.state } })}>{translate('addBlueCard')}</MenuItem>
                            <MenuItem
                                sx={{
                                    whiteSpace: 'normal',
                                    lineHeight: 1.4,
                                    py: 1.5
                                }}
                                onClick={() => navigate(Utils.EndPoint.userMobileEndpoints.addNewBusinessCard, { state: { ...location?.state } })}>{translate('addDealershipHouseAccount')}</MenuItem>
                        </Menu>
                    </Container>
                </div>
                {
                    quote?.id && selectedCard && Object.keys(selectedCard).length > 0 &&
                    <div style={{ height: '10%', padding: '0 16px', display: 'flex', alignItems: 'center' }}><Button
                        disabled={!quote?.total_amount || quote?.total_amount <= 0}
                        style={{ padding: '10px', margin: 0 }} onClick={handlePay}>PAY {paymentConfig?.[0]?.currency_type && paymentConfig?.[0]?.currency_type !== 'default' ? getCurrencySymbol(paymentConfig?.[0]?.currency_type) : '$'} {payments[paymentConfig?.[0]?.currency_type] && payments['USD'] && paymentConfig?.[0]?.currency_type !== 'default' ? ((payments[paymentConfig?.[0]?.currency_type] / payments['USD']) * quote?.total_amount).toFixed(2) : quote?.total_amount}</Button>
                        {isPayingQuotation && <CustomSpinner fullPage top={0} />}
                    </div>
                }
                <OrderPlacedModal
                    open={isOrderPlaced}
                    onClose={(mode) => {
                        setIsOrderPlaced(false)
                        setOrderResponse('')
                        if (mode === 'err') {
                            handlePay()
                        } else {
                            navigate(Utils.EndPoint.userMobileEndpoints.createOrder, {})
                            LocalStorage.removeItem('quote_data')
                        }
                    }}
                    context={rsponse}
                    mode={orderResponse}
                    data={{
                        ...successData,
                        paid: ''
                    }}
                    type="card"
                />
            </PageBox>
        </Layout>
    )
}

export default PaymentMethod
